import { Schema } from '@blade/std-lib'

const NullableString = Schema.UndefinedOrFromOptional(
  Schema.NullOr(Schema.String),
)

const OptionalNumber = Schema.UndefinedOrFromOptional(Schema.Number)

export class GithubUserProfile extends Schema.Class<GithubUserProfile>(
  'GithubUserProfile',
)({
  login: Schema.String,
  avatar_url: Schema.UndefinedOrFromOptional(Schema.URLFromString),
  html_url: Schema.UndefinedOrFromOptional(Schema.URLFromString),
  name: NullableString,
  company: NullableString,
  blog: Schema.UndefinedOrFromOptional(
    Schema.Union([Schema.URLFromString, NullableString]),
  ),
  location: NullableString,
  bio: NullableString,
  twitter_username: NullableString,
  public_repos: OptionalNumber,
  public_gists: OptionalNumber,
  followers: OptionalNumber,
  following: OptionalNumber,
  created_at: Schema.UndefinedOrFromOptional(Schema.DateFromString),
  updated_at: Schema.UndefinedOrFromOptional(Schema.DateFromString),
}) {
  static decode = Schema.decodeUnknownOption(GithubUserProfile)

  get displayName(): string {
    return this.name ?? this.login
  }

  get profileUrl(): string {
    return this.html_url?.toString() ?? `https://github.com/${this.login}`
  }

  get hasVisibleContent(): boolean {
    return Boolean(this.login || this.avatar_url || this.displayName)
  }
}
